<template>
  <div class="saml-idp">
    <h1>Direct Link [WIP]</h1>
    <p>Redirects user to a direct link to swivelpay</p>
    <router-link to="/home" tag="a">return home</router-link>
    <br>

    <div class="block">
      <h2>Environment</h2>
      <ul style="display: inline-block;">
        <li>
          <input v-model="environment" id="dev" type="radio" value="dev" name="dev">
          <label for="dev">DEV</label>
        </li>
        <li>
          <input v-model="environment" id="qa" type="radio" value="qa" name="qa" />
          <label for="qa">QA</label>
        </li>
        <li>
          <input v-model="environment" id="beta" type="radio" value="beta" name="beta" disabled class="disabled" />
          <label for="beta" class="disabled">BETA</label>
        </li>
        <li>
          <input v-model="environment" id="prod" type="radio" value="" name="prod" disabled class="disabled" />
          <label for="prod" class="disabled">PROD</label>
        </li>
      </ul>
    </div>

    <div class="block">
      <h2>Version</h2>
      <ul>
        <li>
          <input v-model="isSSOv2" id="ssov2" type="radio" value="true" name="ssov2">
          <label for="ssov2">SSOv2</label>
        </li>
        <li>
          <input v-model="isSSOv2" id="sso" type="radio" value="false" name="sso" />
          <label for="sso">SSO</label>
        </li>
      </ul>
    </div>

    <div class="block">
      <h2>Application</h2>
      <ul>
        <li>
          <input v-model="isSwivelPay" id="swivelpay" type="radio" value="true" name="swivelpay" disabled class="disabled">
          <label for="swivelpay" class="disabled">SwivelPay</label>
        </li>
        <li>
          <input v-model="isSwivelPay" id="blp" type="radio" value="false" name="blp" disabled class="disabled" />
          <label for="blp" class="disabled">BLP</label>
        </li>
      </ul>
    </div>

    <form @submit="formSubmit">
      <br>
      <textarea cols=120 rows=22 class="form-control" v-model="displayClaims"></textarea>
      <br>
      <button id="login">Login</button>
    </form>
  </div>
</template>

<script>
import config from '../config'

export default {
  name: 'direct',
  props: {
    msg: String
  },
  data() {
    return {
      claim: {},
      environment: 'dev',
      isSSOv2: true,
      isSwivelPay: true
    };
  },
  created(){
    this.claim = {
      "service_provider_url": `https://api.${this.environment}baconpay.com/user/sso/saml/7f781661-c5ff-4682-b048-0163dd9f7cb3`,
      "claims": [{
          "key": "user_id",
          "value": "1515",
          "encoding": "string"
        },
        {
          "key": "fi_id",
          "value": "4078",
          "encoding": "string"
        },
        {
          "key": "xml_data",
          "value": "<userInfo><FullName>Robert Avani</FullName><email>15152@fi.com</email><homePhoneNumber>(307)640-1846</homePhoneNumber></userInfo>",
          "encoding": "base64"
        }
      ]
    }
  },
  watch: {
    environment(newVal) {
      this.claim.service_provider_url = `https://api.${newVal}baconpay.com/user/sso/saml/${this.isSSOv2 ? '7f781661-c5ff-4682-b048-0163dd9f7cb3' : ''}`;
    },
    isSSOv2(newVal) {
      // set url
      let institution = newVal === 'true' ? '7f781661-c5ff-4682-b048-0163dd9f7cb3' : '';
      this.claim.service_provider_url = `https://api.${this.environment}baconpay.com/user/sso/saml/${institution}`;

      //set encoding
      this.claim.claims[2].encoding = newVal === 'true' ? 'base64' : 'string'
    }
  },
  computed: {
    displayClaims: {
      set: function(claim){
        this.claim = JSON.parse(claim)
      },
      get: function(){
        return JSON.stringify(this.claim, null, 2);
      }
    }
  },
  methods: {
    formSubmit(e) {
      console.log(this.displayClaims);
      e.preventDefault();
      let currentObj = this;
      let options = {
        method: 'post',
        url: `${config.apiBaseUrl}/login`,
        data: JSON.parse(this.displayClaims),
        headers: {
          'Content-Type': 'application/json',
        }
      }

      // var serviceProviderUrl = JSON.parse(this.displayClaims).service_provider_url
      const parser = new DOMParser();
      let htmlDoc;

      this.axios(options).then(function (response) {
        // TODO: find a way to watch for the listener on the opened swivelpay page
        var id = 'idp-iframe';

        if (document.getElementById(id)) {
          console.log('ERROR: Bacon Web Client may not be opened more than once.');
          return false;
        }

        htmlDoc = parser.parseFromString(response.data, 'text/html')

        var closeListener = function (event) {
          if (typeof window.removeEventListener !== 'undefined' && event.data === 'closeIframe') {
            var iframe = document.getElementById(id);
            iframe.parentNode.removeChild(iframe);
            window.removeEventListener('message', closeListener);
          }
        };

        if (typeof window.addEventListener !== 'undefined') {
          window.addEventListener('message', closeListener);
        }
      })
      .then(() => {
        console.log("data", htmlDoc.getElementsByTagName('input')[0].value);
        options = {
          method: 'post',
          url: "https://api.devbaconpay.com/user/sso/saml/7f781661-c5ff-4682-b048-0163dd9f7cb3",
          data: "SAMLResponse=" + encodeURIComponent(htmlDoc.getElementsByTagName('input')[0].value),
          maxRedirects: 0,
          headers: {
            'Content-Type': 'text/plain',
          }
        }
        console.log("options", options);

        this.axios(options).then((response) => {
          console.log("response", response);
        })
        console.log("finished call...")
      })
      .catch((error) => {
          currentObj.output = error;
      });
      console.log("finished entire request...")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../styles/main.scss';
</style>
